module.exports = __webpack_public_path__ + "media/old_images/intro-android-jamtland-6934cc0b.png";